var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('h2',{staticClass:"footer-title"},[_vm._v("App Footer")])])
}]

export { render, staticRenderFns }